import React from "react";
import { useNavigate } from "react-router-dom";
import { useUser } from "../../redux/useStore";
import { IoIosArrowBack } from "react-icons/io";

interface PageHeaderProps {
    title: string;
    right?: React.ReactNode;
}

export default function PageHeader(props: PageHeaderProps) {

    const navigate = useNavigate()

    const user = useUser()
    const organisation = user?.organisation;
    const orgLogo = organisation?.logo || null;

    return (

        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 20, width: '100%' }}>
            <div className="page__header">
                <div style={{ display: 'flex', alignItems: 'center' }}>
                    <div style={{ cursor: 'pointer' }} onClick={() => navigate(-1)}>
                        <IoIosArrowBack size={22} style={{ marginRight: 10, cursor: 'pointer' }}
                            onClick={() => navigate(-1)} />
                    </div>
                    <h3 style={{ margin: 0, marginBottom: 5,fontSize:20 }}>{props.title}</h3>
                </div>
            </div>
            <div style={{ display: 'flex', alignItems: 'center', gap: '20px' }}>
                {props.right}
                {orgLogo !== null && (
                    <img
                        src={orgLogo}
                        alt="Organization Logo"
                        className="grading-header-logo"
                    />
                )}
            </div>
        </div>

    )
}